import {
  image_image02,
  image_image03,
  image_service01,
  image_service02,
  image_service03,
  image_sidebanner,
} from "../../assets/img/register-slider";
import { PropsWithChildren } from "react";
import { SvgEvvLogoLight } from "../../assets/svg/index";

export const AuthLayout = (props: PropsWithChildren<any>) => {
  return (
    <div className="company-register-container container m-auto px-lg-3 px-0">
      <div className="sign-in-page-bg p-lg-5 p-md-4 py-2">
        <div className="row">
          <div className="col-md-6 d-flex  m-auto">
            <div className="w-100">
              <div className="text-center registration-image">
                <div>
                  <SvgEvvLogoLight className="img-fluid logo-container-img" />
                </div>
                <h3 className="my-3">The Best EVV Software Solutions</h3>
                <div
                  id="carouselExampleControls"
                  className="carousel slide d-md-flex d-none"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner">
                    <div
                      className="carousel-item active"
                      style={{
                        backgroundImage: `url(${image_image02})`,
                      }}
                    />
                    <div
                      className="carousel-item"
                      style={{
                        backgroundImage: `url(${image_image03})`,
                      }}
                    />
                    <div
                      className="carousel-item"
                      style={{
                        backgroundImage: `url(${image_service01})`,
                      }}
                    />
                    <div
                      className="carousel-item"
                      style={{
                        backgroundImage: `url(${image_service02})`,
                      }}
                    />
                    <div
                      className="carousel-item"
                      style={{
                        backgroundImage: `url(${image_service03})`,
                      }}
                    />
                    <div
                      className="carousel-item"
                      style={{
                        backgroundImage: `url(${image_sidebanner})`,
                      }}
                    />
                  </div>
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 d-flex ">
            <div className="sign-in-page-form w-100 py-3 d-flex flex-column my-auto">
              {props.children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
